import { WebhookSubscriptionEventEnum } from '../types/webhook-settings-interface'

export const mapSubscriptions = (selection: Record<WebhookSubscriptionEventEnum, boolean>) =>
  Object.entries(selection)
    .filter(([_, checked]) => checked)
    .map(([key]) => key) as WebhookSubscriptionEventEnum[]
